import { useEffect, useState, useContext} from 'react';
import { useNavigate } from 'react-router-dom';

import MenuContext from '../store/MenuContext';
import CartClasses from '../components/Cart/Cart.module.css';

import { getLabConfig } from '../utils/api';

const CCiFrame = () => {
	const [content,setContent] = useState('');
	const [loadingIframe, setLoadingIframe] = useState('true');
	const [showiFrame,setShowiFrame] = useState(true);
	const [rCCID,setRCCID] = useState('');
	const [rStatus,setRStatus] = useState('');

    const navigate = useNavigate();
	useEffect(() =>{
		if(!showiFrame) {
			console.log(rCCID);
			console.log(rStatus);
			sessionStorage.setItem('ccID',rCCID);
			if(rCCID =='' || typeof rCCID =='undefined' || rStatus === 'Declined' || rCCID ===null)
				navigate('../CreditCardFailed');
			else{
				navigate('../OrderSuccessful?session_id='+rCCID);
			}
		}
	},[showiFrame,navigate,rCCID]);
	useEffect(() => {
		let rdata2={};
		let rdata='';
		let rdatastatus='';
		console.log('event listener');
		const messageHandler = (ev:MessageEvent<{ type: string, message: string}>) => {
			console.log('ev',ev);
			  if (ev.type !== 'message') return;
			  if (!ev.data) return;
			  console.log(ev.data);
			  try {
				rdata2=JSON.parse(ev.data);
				console.log(rdata2);
			  } catch (e) {
				  return;
			  }
			if (!rdata2.transactionInfo) return;
			rdata=rdata2.transactionInfo.transactionId;
			rdatastatus=rdata2.transactionInfo.authorizationStatus;
			  setRStatus(rdatastatus);
			  setRCCID(rdata);
			  setShowiFrame(false);
			}

			window.addEventListener('message', messageHandler)

			return () => window.removeEventListener('message', messageHandler)
		  }, []);	 
		  
	const menuTheme = useContext(MenuContext);

	//get data for specific order from URL
	const callingURL=window.location.href;
	const URLArray=callingURL.split('/');
	console.log(URLArray);
	const iframeParams={
		amount:URLArray[4],
		firstname:URLArray[5],
		lastname:URLArray[6],
		address:URLArray[7],
		postalCode: URLArray[8],
	};
	console.log(iframeParams);
	const xifinURL="/CreditCardiFrameXIFIN.html"

	function XIFINIframe ({htmlfile, params}){
		const paramString = new URLSearchParams(params).toString();
		console.log(paramString);
		const iframescr=`${htmlfile}?${paramString}`;
		console.log(iframescr)
		return (
		 <iframe
			title="Credit Card iFrame"
			width="100%" 
			height="1300"
			src={iframescr}
			onLoad={()=>setLoadingIframe(false)}
		 />
		 );
	}
	return (
	<>
	 {showiFrame &&
			<div className={CartClasses.testInfo}>
				<h4>{showiFrame} {rCCID} XIFIN iframe</h4>
				<XIFINIframe htmlfile={xifinURL} params={iframeParams}/>
				 {loadingIframe ? <p> Loading ...</p> : null}

			</div>}

	</>
	);
};

export default CCiFrame;


